/**
 * Created by Administrador on 11/04/2016.
 */
(function () {
    'use strict';

    angular
        .module('completeAir')
        .controller('revenueProductionCtrl', revenueProductionCtrl)
        .controller('modalOversold', modalOversold)
        .controller('modalDeactivateActivateClasses', modalDeactivateActivateClasses);

    modalOversold.$inject = ['linkService', '$uibModal', '$uibModalInstance', 'indexX', 'categories', 'categoriesIds', 'segments',
        'isModal', 'revenueProductionService', 'AuthServerProvider'];

    modalDeactivateActivateClasses.$inject = ['linkService', '$uibModal', '$uibModalInstance', 'categories',
        'activateDeactivateClasses', 'flightNumber', 'isModal', 'revenueProductionService', 'AuthServerProvider'];

    function calendarView(vm, datePickerService){
        vm.datePickerOpenStatus = {
            'dateFrom': false,
            'dateTo': false
        };
        vm.pickerButtons = datePickerService.pickerButtons();

        vm.datepickerFrom = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false,
                minDate: false
            },
            closed: function (args) {
                var valueDate = args.closeDate;
                vm.datepickerTo.datepickerOptions.minDate = valueDate;
            }
        };

        vm.datepickerTo = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false,
                minDate: null
            }
        };

        vm.openCalendar = function (date) {
            vm.datePickerOpenStatus[date] = true;
        };
    }

    function revenueProductionCtrl(linkService, tabRevenue, modelAircrafts, categories,
                                   revenueProductionService, datePickerService, plaqueAirCrafts, itineraryService,
                                   $uibModal, flights,$stateParams, messageService, AuthServerProvider) {
        var vm = this;

        vm.linkService = linkService;
        vm.tabs = tabRevenue;
        vm.tabs = tabRevenue;

        vm.pages = flights.page;

        vm.$uibModal = $uibModal;

        vm.searchFrom = {
            'actualDate': ($stateParams.departureDate != "") ? new Date(parseInt($stateParams.departureDate)) : new Date(),
            'plaqueAirCraft': ""
        }//'plaqueAirCraft': $stateParams.aircraftId

        vm.plaqueAirCrafts = (plaqueAirCrafts.data._embedded?plaqueAirCrafts.data._embedded.aircrafts:[]);

        vm.userAccount = AuthServerProvider.getUserAccount();

        for(var c=0; c<vm.plaqueAirCrafts.length; c++){
            if($stateParams.aircraftId!="") {
                if (linkService.getLinkId(vm.plaqueAirCrafts[c]._links.self.href) == $stateParams.aircraftId) {
                    vm.searchFrom.plaqueAirCraft = vm.plaqueAirCrafts[c];
                }
            }
        }

        calendarView(vm, datePickerService)


        vm.itineraryFlights = [];

        var ts = 0;
        var plaque = 0;

        vm.itineraryFlights = getItineraryFlightsProduction(vm.linkService, (flights._embedded?flights._embedded.flights:[]), categories);

        vm.searchProduction = function (isValid, searchForm) {

            ts = Date.parse(searchForm.actualDate);

            vm.plaque = "";
            if (searchForm.plaqueAirCraft) {
                vm.plaque = linkService.getLinkId(searchForm.plaqueAirCraft._links.self.href)
                plaque = vm.plaque;
            }
            linkService.reloadRoute(linkService.getCurrentRouteName(), {page: $stateParams.page, size: $stateParams.size, departureDate: ts, aircraftId: vm.plaque})
        };

        vm.sizeFirstTd = function (position) {
            var size = 0;

            for (var i = 0; i <= vm.itineraryFlights.length; i++) {
                if (i == position) {
                    for (var j = 0; j <= vm.itineraryFlights[i]._embedded.departureflights.length; j++) {
                        if (vm.itineraryFlights[i]._embedded.departureflights[j]) {
                            for (var k = 0; k <= vm.itineraryFlights[i]._embedded.departureflights[j]._embedded.segmentflights.length; k++) {
                                if (vm.itineraryFlights[i]._embedded.departureflights[j]._embedded.segmentflights[k]) {
                                    size = size + vm.itineraryFlights[i]._embedded.departureflights[j]._embedded.segmentflights.length;

                                }
                            }
                        }
                    }
                }
            }

            return size;
        };

        vm.modelAircrafts = (modelAircrafts.data._embedded) ? modelAircrafts.data._embedded.modelAircrafts : [];;
        vm.categories = categories;
        vm.editIndexX = -1;
        vm.auxSegments = [];

        vm.editSegmentItineraryClass = function (indexX) {
            if (vm.editIndexX == indexX || vm.editIndexX == -1) {
                vm.itineraryFlights[indexX].disabledClass = false;
                vm.itineraryFlights[indexX].showEdit = false;
                vm.editIndexX = indexX;
                vm.auxSegments = angular.copy(vm.itineraryFlights[indexX].segments);
            }
        }

        vm.cancelSegmentItineraryClass = function (indexX) {
            vm.itineraryFlights[indexX].disabledClass = true;
            vm.itineraryFlights[indexX].showEdit = true;
            vm.editIndexX = -1;
            vm.itineraryFlights[indexX].segments = angular.copy(vm.auxSegments);
            vm.auxSegments = [];
        }

        vm.saveSegmentItinerary = function (valid, indexX) {

            var save = [];
            if (valid) {
                for (var i = 0; i < vm.itineraryFlights.length; i++) {
                    if (i == indexX) {
                        for (var j = 0; j < vm.itineraryFlights[i].segments.length; j++) {

                            for (var k = 0; k < vm.itineraryFlights[i].segments[j].capacities.length; k++) {
                                var saveObj = {
                                    "active": vm.itineraryFlights[i].segments[j].capacities[k].active,
                                    "classId": parseInt(vm.itineraryFlights[i].segments[j].capacities[k].classId),
                                    "segmentClassId": parseInt(vm.itineraryFlights[i].segments[j].capacities[k].segmentClassId),
                                    "segmentFlightId": parseInt(vm.itineraryFlights[i].segments[j].segmentFlightId),
                                    "value": parseInt(vm.itineraryFlights[i].segments[j].capacities[k].value),
                                    "takeOffCapacity": parseInt(vm.itineraryFlights[i].segments[j].takeOffCapacity)
                                }

                                save.push(saveObj)
                            }

                        }
                    }
                }
                revenueProductionService.updateSegmentItineraries({"segmentClasses": save}, vm.userAccount.userName)
                    .then(function (res) {
                        if (res != "ok") {
                            vm.itineraryFlights[indexX].segments = angular.copy(vm.auxSegments);
                        }
                        vm.itineraryFlights[indexX].disabledClass = true;
                        vm.itineraryFlights[indexX].showEdit = true;
                        vm.editIndexX = -1;
                        vm.auxSegments = [];
                    });

            } else {
                messageService.segmentClassValidity();
            }
        }


        vm.openActivateDeactivateClassesDialog = function (departureDate, departureFlightId, flightNumber, flightId) {

            var modalInstance = vm.$uibModal.open({
                templateUrl: 'app/admin/configGeneral/rates/revenue/revenueProduction/activateDeactivateClasses.html',
                controller: 'modalDeactivateActivateClasses',
                controllerAs: 'vm',
                resolve: {
                    'categories': ['tariffClassService', function (tariffClassService) {
                        return tariffClassService.getFareClassesFare();
                    }],
                    'activateDeactivateClasses': ['revenueProductionService', function (revenueProductionService) {
                        return revenueProductionService.getActivateDeactivateClass(Date.parse(departureDate), flightId);
                    }],
                    'flightNumber': function () {
                        return flightNumber
                    },
                    'isModal': 1
                }
            });
            modalInstance.result.then(function (res) {
            }, function () {
                linkService.reloadRoute(linkService.getCurrentRouteName(), {page: $stateParams.page, size: $stateParams.size, departureDate: $stateParams.departureDate})
            });
        }

        vm.openOversoldDialog = function (indexX, segmentflights) {

            var segmentFlightId = 0;

            if (segmentflights.overLoad) {
                segmentFlightId = parseInt(segmentflights.segmentFlightId)

            }
            var modalInstance = vm.$uibModal.open({
                templateUrl: 'app/admin/configGeneral/rates/revenue/revenueProduction/oversold.html',
                controller: 'modalOversold',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    'indexX': [function () {
                        return indexX
                    }],
                    'categories': ['tariffClassService', function (tariffClassService) {
                        return tariffClassService.getFareClassesFare();
                    }],
                    'categoriesIds': ['itineraryService',function (itineraryService) {
                        return itineraryService.getOverLoad(segmentflights.segmentFlightId);
                    }],
                    'segments': [function () {
                        return segmentflights
                    }],
                    'dataModalObj': [function () {
                        return segmentFlightId;
                    }],
                    'isModal': 1
                }
            });
            modalInstance.result.then(function (res) {
            }, function () {
                linkService.reloadRoute(linkService.getCurrentRouteName(), {page: $stateParams.page, size: $stateParams.size, departureDate: $stateParams.departureDate})
            });
        }
    }

    function getItineraryFlightsProduction(linkService, flights, categories) {
        var segmentItineraries = [];
        var modelAirCraft = "";

        if(flights){
            for (var i = 0; i < flights.length; i++) {

                segmentItineraries.push({
                    "disabledClass": true,
                    "disabledEdit": false,
                    "showEdit": true,
                    "showSave": false,
                    "flightNumber": flights[i].flightNumber,
                    "flightId": linkService.getLinkId(flights[i]._links.self.href),
                    "modelAirCraft": getModelByPosition(flights, i),
                    "segments": []
                })

                for (var j = 0; j < flights[i]._embedded.departureflights.length; j++) {
                    if (flights[i]._embedded.departureflights[j]) {
                        modelAirCraft = flights[i]._embedded.departureflights[j]._embedded.modelAircraft.name;
                        for (var k = 0; k < flights[i]._embedded.departureflights[j]._embedded.segmentflights.length; k++) {
                            if (flights[i]._embedded.departureflights[j]._embedded.segmentflights[k]) {
                                segmentItineraries[i].segments.push(
                                    {
                                        "departureFlightId": parseInt(linkService.getLinkId(flights[i]._embedded.departureflights[j]._links.self.href)),
                                        "active": flights[i].active,
                                        "name": flights[i]._embedded.departureflights[j]._embedded.segmentflights[k]._embedded.segment.name,
                                        "departureTime": moment(flights[i]._embedded.departureflights[j].departureDate).format("HH:mm"),
                                        "capacity": flights[i]._embedded.departureflights[j]._embedded.modelAircraft.capacity,
                                        "takeOffCapacity": flights[i]._embedded.departureflights[j]._embedded.segmentflights[k].takeOffCapacity,
                                        "id": linkService.getLinkId(flights[i]._embedded.departureflights[j]._embedded.segmentflights[k]._links.self.href),
                                        "oversold": flights[i]._embedded.departureflights[j].openOverSold,
                                        "overLoad": flights[i]._embedded.departureflights[j]._embedded.segmentflights[k].overLoad,
                                        "classId": getClassAndClassIdByPosition(linkService, flights[i]._embedded.departureflights[j]._embedded.segmentflights[k]._embedded.segmentClasses).classId,
                                        "segmentFlightId": linkService.getLinkId(flights[i]._embedded.departureflights[j]._embedded.segmentflights[k]._links.self.href),
                                        "capacities": getCapacitiesByPosition(categories, linkService, flights[i]._embedded.departureflights[j]._embedded.segmentflights[k]._embedded.segmentClasses)
                                    }
                                );
                            }
                        }
                    }
                }
            }
        }

        return segmentItineraries;
    }

    function getCapacitiesByPosition(categories, linkService, segmentClasses) {
        var capacities = [];
        for (var c = 0; c < categories.length; c++) {
            for (var cl = 0; cl < categories[c]._embedded.fareClasses.length; cl++) {
                var classId = linkService.getLinkId(categories[c]._embedded.fareClasses[cl]._links.self.href)
                var segmentClass = getSegmentClass(classId, segmentClasses);
                capacities.push(
                    {
                        "classId": classId,
                        "value": segmentClass.value,
                        "segmentClassId": linkService.getLinkId(segmentClass._links.self.href),
                        "active": segmentClass.active,
                    }
                );
            }
        }

        return capacities;
    }

    function getClassAndClassIdByPosition(linkService, segmentClasses) {

        var classes = {};
        for (var i = 0; i < segmentClasses.length; i++) {
            classes = {
                "classId": segmentClasses[i].classId,
                "segmentClassId": linkService.getLinkId(segmentClasses[i]._links.self.href)
            }
        }

        return classes;
    }

    function getModelByPosition(flights, position) {
        var modelAirCraft = "";
        for (var j = 0; j < flights[position]._embedded.departureflights.length; j++) {
            if (flights[position]._embedded.departureflights[j]) {
                modelAirCraft = flights[position]._embedded.departureflights[j]._embedded.modelAircraft.name;
            }
        }
        return modelAirCraft;
    }

    function getSegmentClass(classId, segmentClassItis) {
        var res = 0;
        if (segmentClassItis != undefined) {
            for (var i = 0; i < segmentClassItis.length; i++) {
                if (segmentClassItis[i].classId == classId) {
                    res = segmentClassItis[i];
                    break;
                }
            }
        }
        return res;
    }

    function modalOversold(linkService, $uibModal, $uibModalInstance, indexX, categories, categoriesIds, segments,
                           isModal, revenueProductionService, AuthServerProvider) {

        var vm = this;

        vm.userAccount = AuthServerProvider.getUserAccount();

        vm.indexX = indexX;

        vm.categories = categories;

        vm.selectCheckbox = [];

        for(var k=0; k<categoriesIds._embedded.segmentClasses.length; k++){
            vm.selectCheckbox.push({
                "true": true
            })
        }

        vm.$uibModal = $uibModal;

        vm.oversold = {};

        vm.isModal = isModal;

        vm.segments = segments;

        vm.oversold.selectCheckBox = [];
        vm.oversold.segmentClasses = [];

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        }

        vm.categoriesIds = categoriesIds;
        vm.oversold.overLoad = categoriesIds.overLoad;
        vm.oversold.segmentFlightId = linkService.getLinkId(vm.categoriesIds._links.self.href)
        for(var i =0; i<vm.categories.length; i++){
            for(var j=0; j<vm.categories[i]._embedded.fareClasses.length; j++){
                for(var k=0; k<categoriesIds._embedded.segmentClasses.length; k++){
                    if(linkService.getLinkId(vm.categories[i]._embedded.fareClasses[j]._links.self.href)==categoriesIds._embedded.segmentClasses[k].classId){
                        vm.oversold.selectCheckBox.push(true);
                        vm.oversold.segmentClasses.push({
                            "segmentClassId": categoriesIds._embedded.segmentClasses[k].classId,
                            "hasOverSold": categoriesIds._embedded.segmentClasses[k].hasOverSold
                        });
                    }
                }
            }
        }

        vm.saveOversold = function (isValid, saveOversold) {
            if (isValid) {
                revenueProductionService.updateOversold(saveOversold, vm.userAccount.userName)
                    .then(function (result) {
                        vm.cancel();
                    });
            }
        }
    }

    function getSegmentsById(segmentos, linkService){
        var segmentsArray = [];
        for (var j = 0; j < segmentos.length; j++) {
            segmentsArray.push({
                "data": segmentos[j].active,
                "active": segmentos[j].active,
                "segmentClassId": parseInt(linkService.getLinkId(segmentos[j]._links.self.href)),
                "segments": segmentos[j]
            })
        }
        return segmentsArray;
    }
    function modalDeactivateActivateClasses(linkService, $uibModal, $uibModalInstance, categories,
                                            activateDeactivateClasses, flightNumber, isModal,revenueProductionService, AuthServerProvider) {
        var vm = this;
        vm.nroFlight = flightNumber;
        vm.categories = categories;
        vm.$uibModal = $uibModal;
        vm.isModal = isModal;
        vm.activateDeactivate = [];

        vm.userAccount = AuthServerProvider.getUserAccount();

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        }

        vm.segments = activateDeactivateClasses.data._embedded.segmentflights;

        for (var i = 0; i < vm.segments.length; i++) {
            vm.activateDeactivate.push({
                'segmentFlight': parseInt(linkService.getLinkId(vm.segments[i]._links.self.href)),
                'segments': vm.segments[i]._embedded.segment.name,
                'segmentClassIds': getSegmentsById(vm.segments[i]._embedded.segmentClasses, linkService)
            })
        }

        vm.saveActivateDeactivate = function (isValid, saveActivateDeactivate) {

            if (isValid) {
                var save = {"segmentClassADs": saveActivateDeactivate};
                revenueProductionService.updateActivateDeactivateClass(save, vm.userAccount.userName)
                    .then(function (result) {
                        vm.cancel();
                    });
            }
        }
    }
})();
